import React, {Component} from 'react';
import {MultiSelect as MultiDropdown} from 'react-selectize';
import {generateRandomKey} from 'helpers/hash';

class MultiSelect extends Component {
    constructor(props) {
        super(props);

        const {values = []} = props;

        this.renderKey = this.getRenderKey();

        this.state = {
            isOpen: false,
            selected: values,
        };
    }

    onOpen(value) {
        this.setState({isOpen: value});
    }

    onSelect(selected) {
        const values = selected.map((option) => option.value);

        this.props.onSelect(values);

        this.renderKey = this.getRenderKey();

        this.setState({
            selected,
            isOpen: false,
        });
    }

    getRenderKey() {
        return generateRandomKey();
    }

    render() {
        const {className = 'select-open-top', placeholder = '', options = []} = this.props;

        return (
            <MultiDropdown
                key={this.renderKey}
                disabled={isEmpty(options)}
                className={className}
                onOpenChange={((value) => this.onOpen(value)).bind(this)}
                open={this.state.isOpen}
                options={options}
                values={this.state.selected}
                onValuesChange={((value) => this.onSelect(value)).bind(this)}
                placeholder={placeholder}
            />
        );
    }
}

export default MultiSelect;
